/*
 * Copyright (c) 2025. World Wide Generation Ltd
 */

import React from 'react';
import { SurveyDeadlineReminderForm, SurveyDeadlineReminderFormProps } from './SurveyDeadlineReminderForm';
import { getDate } from '@utils/date';
import { CollapseGroup } from '@g17eco/molecules/collapse-panel';
import './SurveyDeadlineReminder.scss';

export const SurveyDeadlineReminderCollapse = (props: SurveyDeadlineReminderFormProps & { trigger?: React.ReactNode }) => {
  const { trigger = <h6 className='text-ThemeAccentMedium'>Set deadline and submission reminders</h6>, ...formProps } = props;
  return (
    <CollapseGroup initialValue={!formProps.deadlineDate} trigger={trigger}>
      <SurveyDeadlineReminderForm key={getDate(formProps.deadlineDate).toISOString()} {...formProps} />
    </CollapseGroup>
  );
};
